class QuickStartModuleBriefing implements Interfaces.IQuickStartModuleCounter {
    QuickStartModuleCounterMessageBusEventName: string = "notifyUserOnBriefingChange";
    QuickStartModuleCounterGetValueUrl: string = "BriefingBook/GetUnreadBriefingCountByUserId";
}
export default QuickStartModuleBriefing;